import getConfig from 'next/config';
import { useRouter } from 'next/router';
import type { FC, ReactNode } from 'react';
import React, { memo } from 'react';

import type { ThemeName } from '@sravni/design-system-theme';
import { CommonHead } from '@sravni/next-common-head';
import { useTheme } from '@sravni/react-utils';

import { useSelectUser } from '@src/reducers/user';

import { PRELOAD_FONTS, getGtmOptions } from './lib';

interface Props {
  isWhiteLabel?: boolean;
  children?: ReactNode;
}

export const CustomCommonHead: FC<Props> = memo(({ isWhiteLabel, children }) => {
  const { asPath } = useRouter();

  const user = useSelectUser();
  const [theme] = useTheme();

  const analyticsOptions = getGtmOptions({
    userId: user?.sub,
    isWhiteLabel,
    asPath,
    theme: theme as ThemeName,
  });

  return (
    <CommonHead
      cdnUrl={getConfig().publicRuntimeConfig.cdnUrl}
      analyticsOptions={analyticsOptions}
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      designSystem="custom" // хак, чтобы не подтягивались все дефолтные шрифты, зашитые в CommonHead
      preloadedFonts={PRELOAD_FONTS}
    >
      {children}
    </CommonHead>
  );
});

CustomCommonHead.displayName = 'CustomCommonHead';
